export default __webpack_public_path__ + "static/media/numbers.12c378d5.mp3";